define('evicommon/spf/model/filter',['require','exports','module','backbone'],function(require, exports, module){
  var Backbone = require('backbone');

  var Filter = Backbone.Model.extend({

  });

  module.exports = Filter;
});
